import React from "react";
import logo from "../assets/images/logo.png";

export default function Footer() {
  return (
    <a
      className="fixed bottom-0 right-0 flex items-center justify-center h-8 px-3 mb-6 mr-4 text-blue-100 bg-white rounded-full shadow-lg"
      href="https://learnwithsumit.com"
      target="_top"
    >
      <div className="flex items-center justify-center w-6 h-6 rounded-full">
        <img src={logo} alt="" />
      </div>
      <span className="ml-1 text-sm leading-none text-black">
        Project Management App
      </span>
    </a>
  );
}
